// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';

export { API_BASE_URL };

// Labels for UI
export const LABELS = {
    appName: 'Buds Spicy Aliyadans',
    poweredBy: 'Powered by Budsdigit',
    currency: '₹',

    // Navigation
    nav: {
        dashboard: 'Dashboard',
        transactions: 'Transactions',
        invoices: 'Invoices',
        purchaseOrders: 'Purchase Orders',
        customers: 'Customers',
        members: 'Members',
        reports: 'Reports',
        settings: 'Settings'
    },

    // Categories
    categoryTypes: {
        INCOME_SALES: 'Sales Income',
        INCOME_INVESTMENT: 'Investment',
        EXPENSE: 'Expense'
    },

    // Division basis
    divisionBasis: {
        PVC_PIPES: 'As per PVC Pipes',
        PEPPER_PLANTS: 'As per Pepper Plants',
        EQUAL: 'Equal Division',
        INDIVIDUAL: 'Individual'
    },

    // Payment modes
    paymentModes: {
        CASH: 'Cash',
        UPI: 'UPI',
        BANK_TRANSFER: 'Bank Transfer',
        CHEQUE: 'Cheque',
        CARD: 'Card',
        NEFT: 'NEFT',
        RTGS: 'RTGS'
    },

    // Payment status
    paymentStatus: {
        PENDING: 'Pending',
        PARTIAL: 'Partial',
        PAID: 'Paid'
    },

    // PO Status
    poStatus: {
        DRAFT: 'Draft',
        CONFIRMED: 'Confirmed',
        FULFILLED: 'Fulfilled',
        CANCELLED: 'Cancelled'
    }
};

// Format currency
export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '₹0';
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount);
};

// Format date
export const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

// Format date for input
export const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
};

// Dynamic Category Colors
const CATEGORY_PALETTE = [
    { bg: '#e0f2f1', text: '#00695c', border: '#b2dfdb' }, // Teal
    { bg: '#e3f2fd', text: '#1565c0', border: '#bbdefb' }, // Blue
    { bg: '#f1f8e9', text: '#33691e', border: '#dcedc8' }, // Light Green
    { bg: '#fff3e0', text: '#ef6c00', border: '#ffe0b2' }, // Orange
    { bg: '#fce4ec', text: '#c2185b', border: '#f8bbd0' }, // Pink
    { bg: '#f3e5f5', text: '#7b1fa2', border: '#e1bee7' }, // Purple
    { bg: '#efebe9', text: '#4e342e', border: '#d7ccc8' }, // Brown
    { bg: '#e8f5e9', text: '#2e7d32', border: '#c8e6c9' }, // Green
    { bg: '#fffde7', text: '#fbc02d', border: '#fff9c4' }, // Yellow
    { bg: '#e8eaf6', text: '#1a237e', border: '#c5cae9' }, // Indigo
];

export const getCategoryStyle = (name) => {
    if (!name) return CATEGORY_PALETTE[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % CATEGORY_PALETTE.length;
    return CATEGORY_PALETTE[index];
};
